import * as z from "zod/v4";
export const ProfileEmailSourceSchema = z.enum([
    "CONTEXTUAL",
    "VOLDEMORT",
    "UNSPECIFIED",
]);
//# sourceMappingURL=profile-email-source.js.map